import { Notificationid } from '../models/notificationid.model';
import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private ApiService = inject(ApiService);

  getNotification(): Observable<any> {
    return this.ApiService.getAll(`notification?state=ALTA`);
  }

  updateNotification(data: any, id: number) {
    return this.ApiService.update(`notification/${id}`, data, id);
  }
}
